<template>
      <div>
            <!-- Headline -->
            <div class="flex xs-12 xs-middle">
                  <div class="flex xs-6 xs-left fs5 lh125 fw7 c1 mb2">{{ $t("holder") }}</div>
                  <div class="flex xs-6 xs-right lh125 c1 mb2">
                        <j-button
                              v-if="$store.state.settings.quotes.detail.hasChangeHolder"
                              type="tertiary"
                              @click="$modal.show('changeHolder')"
                        >
                              <crm-icon name="edit" size="xsmall" color="c2"/>
                              {{ $t("change_holder") }}
                        </j-button>
                  </div>
            </div>

            <!-- Body -->
            <core-entity-card :entity="holder" :isExpanded="false"/>

            <!-- Modal for Change Holder -->
            <core-modal name="changeHolder" :headline="$t('change_holder')">
                  <select-client
                        for="change_holder"
                        @saved="handleSave()"
                        @cancelled="$modal.hide('changeHolder')"
                  />
            </core-modal>
      </div>
</template>

<script>
import CoreEntityCard from "@/modules/core/components/CoreEntityCard/"
import JButton from "@/components/JButton/"
import CrmIcon from "@/components/CrmIcon/"
import JCard from "@/components/JCard/"
import CoreModal from "@/modules/core/components/CoreModal"
import SelectClient from "../components/SelectClient"
import api from "../api/"

export default {
	components: {
		CoreEntityCard,
		JButton,
		JCard,
		CoreModal,
		SelectClient,
		CrmIcon
	},
	props: {
		holder: {
			type: Object,
			required: true,
			default: () => {}
		}
	},
	methods: {
		handleSave() {
			this.$emit("afterChangeHolder")
			this.$modal.hide("changeHolder")
		}
	}
}
</script>
